import { dispatchEventBus } from "@catchoftheday/state";

export const TRIGGER_ADULT_MODAL_EVENT = {
  type: "@global/TRIGGER_ADULT_MODAL",
};

type TriggerAdultModalPayload = {
  open: boolean;
};

export const triggerAdultModal = (payload: TriggerAdultModalPayload) => {
  dispatchEventBus<typeof payload>({
    type: TRIGGER_ADULT_MODAL_EVENT.type,
    payload,
  });
};
